// Dit bestand is ooit samengesteld uit tools/size-engine.js + tools/size-finder-ui.js.
// Die bronnen staan niet in deze repo en ook niet in de git-geschiedenis, dus dít
// bestand IS de bron — bewerk het hier en nergens anders.
// Größen-Finder rekenkern — één codepad voor alle routes.
// Draait identiek in de browser (thema) en in Node (property-test):
//   confectiemaat  → standaard-lichaamsmaten → cm-classifier
//   lichaamsmaten  → cm-classifier
//   schoenmaat     → direct label / voetlengte → voetkolom
// De cm-classifier kalibreert per tabel de ease (tabelwaarde − standaardlichaam),
// zodat stretch (negatieve ease) en wijde pasvormen zichzelf corrigeren.
// Regels: advies alleen op kolommen die we begrijpen én die oplopen; twijfel
// tussen twee maten → pasvoorkeur; nooit een maat adviseren die niet verkocht wordt
// zonder dat eerlijk te zeggen.
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.SizeEngine = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // maatladder + standaard-lichaamsmaten (cm, middenwaarden EU-confectie)
  var LADDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  var BODY = {
    f: { bust: [76, 80, 84, 88, 92, 97, 102, 107, 112, 117],
         waist: [58, 62, 66, 70, 74, 79, 84, 89, 94, 99],
         hip: [83, 87, 91, 95, 99, 104, 109, 114, 119, 124] },
    m: { bust: [84, 88, 92, 96, 100, 104, 108, 112, 116, 120],
         waist: [72, 76, 80, 84, 88, 92, 96, 100, 104, 108],
         hip: [88, 92, 96, 100, 104, 108, 112, 116, 120, 124] },
  };
  var ADVICE_COLS = ['bust', 'waist', 'hip'];
  var COL_WEIGHT = { bust: 2, waist: 1, hip: 1.5 };

  function ladderIdx(label) { return LADDER.indexOf(String(label).toUpperCase()); }
  function cellNum(v) {
    if (v == null) return null;
    if (typeof v.v === 'number') return v.v;
    if (typeof v.min === 'number' && typeof v.max === 'number') return (v.min + v.max) / 2;
    return null;
  }

  // bruikbare advieskolommen van een sectie: bekend, ≥2 getallen, niet-dalend,
  // en de maatlabels moeten op de ladder liggen (anders geen kalibratie mogelijk)
  function adviceColumns(section, gender) {
    var rows = section.rows.filter(function (r) { return ladderIdx(r.size) >= 0; });
    if (rows.length < 2) return [];
    var out = [];
    section.columns.forEach(function (col, ci) {
      if (ADVICE_COLS.indexOf(col.key) < 0) return;
      var pts = rows.map(function (r) {
        var n = cellNum(r.values[ci]);
        return n === null ? null : { size: r.size, li: ladderIdx(r.size), val: n };
      }).filter(Boolean);
      if (pts.length < 2) return;
      for (var i = 1; i < pts.length; i++) if (pts[i].val < pts[i - 1].val) return; // niet-monotoon → overslaan
      var ref = BODY[gender][col.key];
      var ease = 0;
      pts.forEach(function (p) { ease += p.val - ref[p.li]; });
      ease /= pts.length;
      out.push({ key: col.key, ci: ci, pts: pts, ease: ease });
    });
    return out;
  }

  // lichaamsmaat → index binnen pts (dichtstbijzijnd gekalibreerd centrum)
  function classify(colInfo, bodyVal) {
    var best = 0, bestD = Infinity;
    colInfo.pts.forEach(function (p, i) {
      var d = Math.abs(bodyVal - (p.val - colInfo.ease));
      if (d < bestD) { bestD = d; best = i; }
    });
    return { idx: best, dist: bestD };
  }

  // kies de sectie waarop we adviseren: liefst één met borst, anders de eerste bruikbare
  function pickSection(chart, gender) {
    var cand = null;
    for (var i = 0; i < chart.sections.length; i++) {
      var cols = adviceColumns(chart.sections[i], gender);
      if (!cols.length) continue;
      if (cols.some(function (c) { return c.key === 'bust'; })) return { section: chart.sections[i], cols: cols };
      if (!cand) cand = { section: chart.sections[i], cols: cols };
    }
    return cand;
  }

  function findFootSection(chart) {
    for (var i = 0; i < chart.sections.length; i++) {
      var ci = chart.sections[i].columns.findIndex(function (c) { return c.key === 'foot'; });
      if (ci >= 0) return { section: chart.sections[i], ci: ci };
    }
    return null;
  }

  // capability: welke route kan deze tabel aan?
  //  'body'  → wizard met lichaamsmaten + confectiemaat
  //  'shoe'  → schoenmaat/voetlengte
  //  null    → alleen tabel tonen
  function capability(chart, gender) {
    if (chart.type === 'one_size') return null;
    if (findFootSection(chart)) return 'shoe';
    return pickSection(chart, gender || 'f') ? 'body' : null;
  }

  // profile: { gender:'f'|'m', fitPref:0|1  (1 = liever losser),
  //   mode:'konf'  konfIdx: index op LADDER
  //   mode:'body'  measures:{bust?,waist?,hip?}
  //   mode:'shoe'  euSize? footLen?
  //   soldSizes: ['S','M',...]  (verkochte maten van het product) }
  function recommend(chart, profile) {
    var gender = profile.gender === 'm' ? 'm' : 'f';
    var sold = (profile.soldSizes || []).map(function (s) { return String(s).toUpperCase(); });
    var isSold = function (size) { return !sold.length || sold.indexOf(String(size).toUpperCase()) >= 0; };

    /* ---- schoenen ---- */
    if (profile.mode === 'shoe') {
      var fs = findFootSection(chart);
      if (!fs) return { status: 'no_advice' };
      var rows = fs.section.rows;
      var idx = -1, reasons = [];
      if (profile.euSize != null) {
        idx = rows.findIndex(function (r) { return String(r.size) === String(profile.euSize); });
        if (idx >= 0) reasons.push({ kind: 'shoe_label', size: rows[idx].size });
      }
      if (idx < 0 && typeof profile.footLen === 'number') {
        for (var i = 0; i < rows.length; i++) {
          var n = cellNum(rows[i].values[fs.ci]);
          if (n !== null && n >= profile.footLen + 0.3) { idx = i; break; }
        }
        if (idx < 0) idx = rows.length - 1;
        reasons.push({ kind: 'foot', value: profile.footLen, size: rows[idx].size });
      }
      if (idx < 0) return { status: 'no_advice' };
      var size = rows[idx].size;
      if (!isSold(size)) return { status: 'unavailable', size: size, altSize: nearestSold(rows, idx, isSold), reasons: reasons };
      return { status: 'ok', size: size, sizeIdx: idx, reasons: reasons, confidence: 'high' };
    }

    /* ---- kleding: confectiemaat of lichaamsmaten → zelfde classifier ---- */
    var picked = pickSection(chart, gender);
    if (!picked) return { status: 'no_advice' };
    var cols = picked.cols;

    var measures = {};
    var reasons2 = [];
    if (profile.mode === 'konf') {
      if (typeof profile.konfIdx !== 'number' || profile.konfIdx < 0 || profile.konfIdx >= LADDER.length) return { status: 'no_advice' };
      cols.forEach(function (c) { measures[c.key] = BODY[gender][c.key][profile.konfIdx]; });
      reasons2.push({ kind: 'konf', ladder: LADDER[profile.konfIdx] });
    } else {
      measures = profile.measures || {};
    }

    var votes = [], usable = [];
    cols.forEach(function (c) {
      var mv = measures[c.key];
      if (typeof mv !== 'number') return;
      var r = classify(c, mv);
      votes.push({ key: c.key, idx: r.idx, dist: r.dist, w: COL_WEIGHT[c.key] || 1 });
      usable.push(c);
      reasons2.push({ kind: 'measure', col: c.key, value: mv, size: c.pts[r.idx].size, ease: c.ease });
    });
    if (!votes.length) return { status: 'no_advice' };

    var wsum = 0, isum = 0;
    votes.forEach(function (v) { wsum += v.w; isum += v.idx * v.w; });
    var fracIdx = isum / wsum;
    var idx2 = Math.round(fracIdx);
    // twijfel (bijna precies tussen twee maten) → pasvoorkeur beslist
    if (Math.abs(fracIdx - Math.floor(fracIdx) - 0.5) < 0.17) {
      idx2 = profile.fitPref === 1 ? Math.ceil(fracIdx) : Math.floor(fracIdx);
      reasons2.push({ kind: 'tiebreak', looser: profile.fitPref === 1 });
    } else if (profile.fitPref === 1) {
      idx2 = Math.min(idx2 + 1, cols[0].pts.length - 1);
      reasons2.push({ kind: 'sizeup' });
    }
    idx2 = Math.max(0, Math.min(idx2, cols[0].pts.length - 1));

    var agree = votes.every(function (v) { return v.idx === votes[0].idx; });
    var stretch = cols.some(function (c) { return c.ease < -4; });
    if (stretch) reasons2.push({ kind: 'stretch' });

    var recSize = cols[0].pts[idx2].size;
    if (!isSold(recSize)) {
      var rowsAll = cols[0].pts;
      return { status: 'unavailable', size: recSize, altSize: nearestSoldPts(rowsAll, idx2, isSold), reasons: reasons2 };
    }
    return { status: 'ok', size: recSize, sizeIdx: idx2, reasons: reasons2, confidence: agree ? 'high' : 'medium' };
  }

  function nearestSold(rows, idx, isSold) {
    for (var d = 1; d < rows.length; d++) {
      if (idx - d >= 0 && isSold(rows[idx - d].size)) return rows[idx - d].size;
      if (idx + d < rows.length && isSold(rows[idx + d].size)) return rows[idx + d].size;
    }
    return null;
  }
  function nearestSoldPts(pts, idx, isSold) {
    for (var d = 1; d < pts.length; d++) {
      if (idx - d >= 0 && isSold(pts[idx - d].size)) return pts[idx - d].size;
      if (idx + d < pts.length && isSold(pts[idx + d].size)) return pts[idx + d].size;
    }
    return null;
  }

  // ── schoenentabel gelijktrekken ────────────────────────────────────────────
  // Draait alleen als cmMap gevuld is, en dat is precies bij schoeisel:
  // shoe-size-conversion.liquid geeft anders niets terug. Een kledingtabel gaat
  // hier dus ongemoeid doorheen.
  //
  // Drie dingen worden rechtgezet:
  //  1. De us- en uk-kolom van de leverancier gaat eruit. Die is voor heren en
  //     dames identiek terwijl dezelfde voet anderhalve maat scheelt, hij
  //     springt tussen EU 37 en 38 anderhalve maat waar elke andere stap een
  //     halve maat is, en hij staat maar bij 79 van de 263 schoenen.
  //  2. foot_length heet voortaan foot. Zonder die naam vond findFootSection()
  //     de kolom niet, kreeg het product géén maatadvies, en stond er letterlijk
  //     "col_foot_length" boven de kolom omdat die vertaalsleutel niet bestaat.
  //  3. De voetlengte komt uit de Paris-point-schaal in plaats van de stapjes
  //     van 5 mm uit de bron, die bij EU 48 anderhalve centimeter te kort zit.
  //
  // De maat van deze markt komt er vooraan bij, uit dezelfde bron als de regel
  // onder de maatknoppen. Tabel en knoppen kunnen zo niet uiteenlopen.
  function parseMap(raw) {
    var out = {};
    String(raw || '').split('|').forEach(function (part) {
      var kv = part.split('=');
      if (kv.length === 2 && kv[0]) out[kv[0]] = kv[1];
    });
    return out;
  }

  function normalizeShoeChart(chart, opts) {
    var cmMap = parseMap(opts && opts.cmMap);
    if (!Object.keys(cmMap).length) return chart;
    var altMap = parseMap(opts && opts.altMap);
    var hasAlt = !!(opts && opts.altField) && Object.keys(altMap).length > 0;

    (chart.sections || []).forEach(function (sec) {
      var cols = [], srcIdx = [];
      (sec.columns || []).forEach(function (c, i) {
        if (/^(us|uk)(_size)?$/.test(c.key)) return;
        if (c.key.indexOf('foot') === 0) c = { key: 'foot', label: c.label, unit: 'cm' };
        cols.push(c); srcIdx.push(i);
      });
      var footAt = -1;
      cols.forEach(function (c, i) { if (c.key === 'foot') footAt = i; });

      (sec.rows || []).forEach(function (r) {
        var vals = srcIdx.map(function (i) { return r.values[i]; });
        if (footAt >= 0 && cmMap[r.size] != null) vals[footAt] = { v: parseFloat(cmMap[r.size]) };
        if (hasAlt) vals.unshift(altMap[r.size] != null ? { v: parseFloat(altMap[r.size]) } : null);
        r.values = vals;
      });
      // direct naast de EU-maat, want dat is de kolom waar de klant heen kijkt
      if (hasAlt) cols.unshift({ key: 'alt', label: opts.altLabel, unit: '' });
      sec.columns = cols;

      // Maten die wél verkocht worden maar niet in de tabel staan. Dat is geen
      // uitzondering: de leverancierstabel loopt bij 5 producten niet ver genoeg
      // door en noteert dat zelf in missingSizes. De klant koos dan een maat
      // waarover de tabel zweeg en kreeg geen advies.
      // Mag alleen omdat élke kolom van een schoenensectie hier inmiddels
      // afgeleid is: voetlengte uit de Paris-point-schaal, de maat uit de
      // omrekentabel. Staat er nog een gemeten kolom bij, dan blijven we eraf —
      // liever een gat dan een verzonnen centimeter.
      var afleidbaar = cols.every(function (c) { return c.key === 'alt' || c.key === 'foot'; });
      var sold = opts.soldSizes || [];
      if (afleidbaar && cols.length && sold.length) {
        var aanwezig = {};
        sec.rows.forEach(function (r) { aanwezig[String(r.size)] = true; });
        sold.forEach(function (s) {
          var maat = String(s).trim();
          if (aanwezig[maat] || cmMap[maat] == null) return;
          aanwezig[maat] = true;
          sec.rows.push({
            size: maat,
            sizeRaw: maat,
            values: cols.map(function (c) {
              if (c.key === 'foot') return { v: parseFloat(cmMap[maat]) };
              return altMap[maat] != null ? { v: parseFloat(altMap[maat]) } : null;
            }),
          });
        });
        // De adviseur loopt de rijen op volgorde af en pakt de eerste voet die
        // groot genoeg is; ongesorteerd geeft dat de verkeerde maat. Alleen
        // sorteren als élke maat een getal is — op letters zou parseFloat NaN
        // geven en de volgorde juist slopen.
        var numeriek = sec.rows.every(function (r) { return !isNaN(parseFloat(r.size)); });
        if (numeriek) sec.rows.sort(function (a, b) { return parseFloat(a.size) - parseFloat(b.size); });
      }
    });
    return chart;
  }

  return {
    LADDER: LADDER, BODY: BODY, recommend: recommend, capability: capability,
    adviceColumns: adviceColumns, normalizeShoeChart: normalizeShoeChart,
  };
});

// Größen-Finder UI — leest #size-finder-data, rendert link-status, sheet,
// wizard en tabel. De rekenlogica komt uit SizeEngine (zelfde bestand,
// eronder geconcateneerd bij de build). Profiel in localStorage werkt
// winkel-breed: één keer invullen, elke PDP rekent zijn eigen tabel door.
(function () {
  'use strict';
  var dataEl = document.getElementById('size-finder-data');
  var root = document.getElementById('size-finder-root');
  if (!dataEl || !root || !window.SizeEngine) return;
  var E = window.SizeEngine;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var S = D.strings || {};
  var chart = D.chart || {};
  chart.type = D.chartType;
  var gender = D.gender === 'm' ? 'm' : 'f';
  var soldSizes = D.soldSizes || [];

  // Schoenentabel gelijktrekken vóór capability(): de omgedoopte foot-kolom is
  // precies wat de adviseur nodig heeft om de schoenroute te herkennen.
  E.normalizeShoeChart(chart, {
    cmMap: D.cmMap, altMap: D.altMap, altField: D.altField, altLabel: D.altLabel,
    soldSizes: soldSizes,
  });
  var cap = E.capability(chart, gender);
  var isEn = D.locale === 'en';

  var PROFILE_KEY = 'cl_size_profile_v1';
  function loadProfile() { try { return JSON.parse(localStorage.getItem(PROFILE_KEY) || 'null') || {}; } catch (e) { return {}; } }
  function saveProfile(p) { try { localStorage.setItem(PROFILE_KEY, JSON.stringify(p)); } catch (e) {} }
  var profile = loadProfile();

  function t(key, vars) {
    var s = S[key] || key;
    if (vars) for (var k in vars) s = s.split('{' + k + '}').join(vars[k]);
    return s;
  }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* ---------- link naast het maat-label ---------- */
  var link = document.querySelector('[data-size-finder-open]');
  if (!link) return;
  link.hidden = false;
  if (!cap) {
    var lbl = link.querySelector('[data-sf-link-label]');
    if (lbl) lbl.textContent = t('table_link_label');
  }

  /* ---------- confectie-ladders per markt/geslacht ---------- */
  function konfChips() {
    if (gender === 'm') return E.LADDER.slice(1, 9).map(function (s, i) { return { label: s, idx: i + 1 }; });
    var labels = isEn ? [4, 6, 8, 10, 12, 14, 16, 18, 20, 22] : [32, 34, 36, 38, 40, 42, 44, 46, 48, 50];
    return labels.map(function (l, i) { return { label: String(l), idx: i }; });
  }

  /* ---------- sheet skeleton ---------- */
  var back = el('div', 'sf-back');
  var sheet = el('div', 'sf-sheet');
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  sheet.innerHTML =
    '<div class="sf-hd"><div class="sf-grab"></div>' +
    '<div class="sf-top"><span class="sf-title">' + t('sheet_title') + '</span>' +
    '<button type="button" class="sf-x" aria-label="' + t('close') + '">&#10005;</button></div>' +
    (cap ? '<div class="sf-tabs"><button type="button" class="sf-tab on" data-sf-tab="advisor">' + t('tab_advisor') + '</button>' +
      '<button type="button" class="sf-tab" data-sf-tab="table">' + t('tab_table') + '</button></div>' : '') +
    '</div>' +
    '<div class="sf-body" data-sf-pane="advisor"></div>' +
    '<div class="sf-body" data-sf-pane="table" hidden></div>';
  root.hidden = false;
  root.appendChild(back);
  root.appendChild(sheet);
  var paneAdvisor = sheet.querySelector('[data-sf-pane="advisor"]');
  var paneTable = sheet.querySelector('[data-sf-pane="table"]');
  if (!cap) paneAdvisor.hidden = true;

  function openSheet(tab) {
    back.classList.add('on'); sheet.classList.add('on');
    document.documentElement.classList.add('sf-lock');
    setTab(cap ? (tab || 'advisor') : 'table');
  }
  function closeSheet() {
    back.classList.remove('on'); sheet.classList.remove('on');
    document.documentElement.classList.remove('sf-lock');
  }
  function setTab(name) {
    sheet.querySelectorAll('.sf-tab').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-sf-tab') === name); });
    paneAdvisor.hidden = name !== 'advisor';
    paneTable.hidden = name !== 'table';
    if (name === 'table') renderTable();
  }
  back.addEventListener('click', closeSheet);
  sheet.querySelector('.sf-x').addEventListener('click', closeSheet);
  sheet.querySelectorAll('.sf-tab').forEach(function (b) {
    b.addEventListener('click', function () { setTab(b.getAttribute('data-sf-tab')); });
  });
  link.addEventListener('click', function (e) { e.preventDefault(); openSheet(); });

  /* ---------- wizard ---------- */
  var unit = isEn ? 'in' : 'cm';
  var state = {
    mode: profile.mode || (cap === 'shoe' ? 'shoe' : 'konf'),
    konfIdx: typeof profile.konfIdx === 'number' ? profile.konfIdx : null,
    measures: profile.measures || {},
    euSize: profile.euSize || null,
    footLen: typeof profile.footLen === 'number' ? profile.footLen : null,
    fitPref: typeof profile.fitPref === 'number' ? profile.fitPref : null,
    rec: null,
  };
  if (cap === 'shoe' && state.mode !== 'shoe' && state.mode !== 'foot') state.mode = 'shoe';
  if (cap === 'body' && (state.mode === 'shoe' || state.mode === 'foot')) state.mode = 'konf';

  function persist() {
    profile.mode = state.mode; profile.konfIdx = state.konfIdx; profile.measures = state.measures;
    profile.euSize = state.euSize; profile.footLen = state.footLen; profile.fitPref = state.fitPref;
    saveProfile(profile);
  }

  function adviceCols() {
    var picked = null;
    for (var i = 0; i < (chart.sections || []).length; i++) {
      var cols = E.adviceColumns(chart.sections[i], gender);
      if (cols.length && (cols.some(function (c) { return c.key === 'bust'; }) || !picked)) picked = cols;
      if (picked && picked.some(function (c) { return c.key === 'bust'; })) break;
    }
    return picked || [];
  }

  function buildProfileArg() {
    if (cap === 'shoe') {
      if (state.mode === 'foot' && state.footLen) return { mode: 'shoe', footLen: state.footLen, fitPref: state.fitPref === 2 ? 1 : 0, soldSizes: soldSizes, gender: gender };
      if (state.euSize) return { mode: 'shoe', euSize: state.euSize, fitPref: 0, soldSizes: soldSizes, gender: gender };
      return null;
    }
    if (state.fitPref == null) return null;
    var fp = state.fitPref === 2 ? 1 : 0;
    if (state.mode === 'body') {
      var have = false, cols = adviceCols();
      var meas = {};
      cols.forEach(function (c) { if (typeof state.measures[c.key] === 'number') { meas[c.key] = state.measures[c.key]; have = true; } });
      if (!have) return null;
      return { mode: 'body', measures: meas, fitPref: fp, soldSizes: soldSizes, gender: gender };
    }
    if (state.konfIdx == null) return null;
    return { mode: 'konf', konfIdx: state.konfIdx, fitPref: fp, soldSizes: soldSizes, gender: gender };
  }

  function renderAdvisor() {
    paneAdvisor.innerHTML = '';
    if (cap === 'shoe') {
      var sec = null, ci = -1;
      (chart.sections || []).forEach(function (s) {
        var i = s.columns.findIndex(function (c) { return c.key === 'foot'; });
        if (i >= 0 && !sec) { sec = s; ci = i; }
      });
      if (state.mode === 'shoe') {
        paneAdvisor.appendChild(el('p', 'sf-q', t('q_shoe')));
        paneAdvisor.appendChild(el('p', 'sf-hint', t('q_shoe_hint')));
        var chips = el('div', 'sf-chips');
        sec.rows.forEach(function (r) {
          var b = el('button', 'sf-chip' + (String(state.euSize) === String(r.size) ? ' on' : ''), r.size);
          b.type = 'button';
          b.addEventListener('click', function () { state.euSize = r.size; persist(); renderAdvisor(); });
          chips.appendChild(b);
        });
        paneAdvisor.appendChild(chips);
        var sw = el('button', 'sf-swap', t('alt_foot'));
        sw.type = 'button';
        sw.addEventListener('click', function () { state.mode = 'foot'; persist(); renderAdvisor(); });
        paneAdvisor.appendChild(sw);
      } else {
        paneAdvisor.appendChild(el('p', 'sf-q', t('q_foot')));
        paneAdvisor.appendChild(el('p', 'sf-hint', t('q_foot_hint')));
        var mf = el('div', 'sf-field');
        mf.innerHTML = '<label>' + t('col_foot') + '</label><div class="sf-inp"><input type="number" inputmode="decimal" min="18" max="35" step="0.5" value="' + (state.footLen || '') + '"><span>cm</span></div>';
        mf.querySelector('input').addEventListener('input', function () {
          var v = parseFloat(this.value); state.footLen = isNaN(v) ? null : v; persist(); renderResult();
        });
        paneAdvisor.appendChild(mf);
        var sw2 = el('button', 'sf-swap', t('back_shoe'));
        sw2.type = 'button';
        sw2.addEventListener('click', function () { state.mode = 'shoe'; persist(); renderAdvisor(); });
        paneAdvisor.appendChild(sw2);
      }
    } else {
      if (state.mode === 'konf') {
        paneAdvisor.appendChild(el('p', 'sf-q', t('q_konf')));
        paneAdvisor.appendChild(el('p', 'sf-hint', gender === 'm' ? t('q_konf_hint_m') : (isEn ? t('q_konf_hint_uk') : t('q_konf_hint_eu'))));
        var kc = el('div', 'sf-chips');
        konfChips().forEach(function (c) {
          var b = el('button', 'sf-chip' + (state.konfIdx === c.idx ? ' on' : ''), c.label);
          b.type = 'button';
          b.addEventListener('click', function () { state.konfIdx = c.idx; persist(); renderAdvisor(); });
          kc.appendChild(b);
        });
        paneAdvisor.appendChild(kc);
        var sw3 = el('button', 'sf-swap', t('alt_measures'));
        sw3.type = 'button';
        sw3.addEventListener('click', function () { state.mode = 'body'; persist(); renderAdvisor(); });
        paneAdvisor.appendChild(sw3);
      } else {
        paneAdvisor.appendChild(el('p', 'sf-q', t('q_measures')));
        paneAdvisor.appendChild(el('p', 'sf-hint', t('q_measures_hint')));
        var wrap = el('div', 'sf-fields');
        adviceCols().forEach(function (c) {
          var f = el('div', 'sf-field');
          f.innerHTML = '<label>' + t('col_' + c.key) + '</label><div class="sf-inp"><input type="number" inputmode="numeric" min="50" max="160" value="' + (state.measures[c.key] || '') + '"><span>cm</span></div>';
          f.querySelector('input').addEventListener('input', function () {
            var v = parseFloat(this.value);
            if (isNaN(v)) delete state.measures[c.key]; else state.measures[c.key] = v;
            persist(); renderResult();
          });
          wrap.appendChild(f);
        });
        paneAdvisor.appendChild(wrap);
        var sw4 = el('button', 'sf-swap', t('back_konf'));
        sw4.type = 'button';
        sw4.addEventListener('click', function () { state.mode = 'konf'; persist(); renderAdvisor(); });
        paneAdvisor.appendChild(sw4);
      }
      // pasvoorkeur
      var q2 = el('div', 'sf-step2');
      q2.appendChild(el('p', 'sf-q', t('q_fit')));
      var fc = el('div', 'sf-chips sf-chips--fit');
      [t('fit_1'), t('fit_2'), t('fit_3')].forEach(function (lbl, i) {
        var b = el('button', 'sf-chip sf-chip--fit' + (state.fitPref === i ? ' on' : ''), lbl);
        b.type = 'button';
        b.addEventListener('click', function () { state.fitPref = i; persist(); renderAdvisor(); });
        fc.appendChild(b);
      });
      q2.appendChild(fc);
      paneAdvisor.appendChild(q2);
    }
    // resultaat + reset
    paneAdvisor.appendChild(el('div', 'sf-result', ''));
    var reset = el('button', 'sf-reset', t('reset'));
    reset.type = 'button';
    reset.addEventListener('click', function () {
      try { localStorage.removeItem(PROFILE_KEY); } catch (e) {}
      profile = {}; state.konfIdx = null; state.measures = {}; state.euSize = null; state.footLen = null; state.fitPref = null; state.rec = null;
      state.mode = cap === 'shoe' ? 'shoe' : 'konf';
      clearApplied(); renderAdvisor();
    });
    paneAdvisor.appendChild(reset);
    renderResult();
  }

  function reasonLines(rec) {
    var out = [];
    (rec.reasons || []).forEach(function (r) {
      if (r.kind === 'konf') out.push(t('r_konf', { k: konfLabelFor(state.konfIdx), size: rec.size }));
      else if (r.kind === 'measure') out.push(t('r_measure', { col: t('col_' + r.col), v: r.value, size: r.size }));
      else if (r.kind === 'stretch') out.push(t('r_stretch'));
      else if (r.kind === 'sizeup' || (r.kind === 'tiebreak' && r.looser)) out.push(t('r_sizeup'));
      else if (r.kind === 'foot') out.push(t('r_foot', { v: r.value, size: r.size }));
    });
    return out;
  }
  function konfLabelFor(idx) {
    var c = konfChips().filter(function (x) { return x.idx === idx; })[0];
    return c ? c.label : '';
  }

  function renderResult() {
    var box = paneAdvisor.querySelector('.sf-result');
    if (!box) return;
    var arg = buildProfileArg();
    if (!arg) { box.innerHTML = ''; box.classList.remove('show'); state.rec = null; return; }
    var rec = E.recommend(chart, arg);
    state.rec = rec;
    if (rec.status === 'no_advice') { box.innerHTML = ''; box.classList.remove('show'); return; }
    box.classList.add('show');
    var lines = reasonLines(rec).map(function (l) { return '<li>' + l + '</li>'; }).join('');
    if (rec.status === 'unavailable') {
      box.classList.add('unavail');
      box.innerHTML =
        '<div class="sf-kick">' + t('result_kick') + '</div>' +
        '<div class="sf-hero"><div class="sf-sz sf-sz--na">' + rec.size + '</div>' +
        '<div><div class="sf-rt">' + t('result_unavailable', { size: rec.size }) + '</div>' +
        '<div class="sf-rs">' + (rec.altSize ? t('result_unavailable_sub', { alt: rec.altSize }) : t('result_unavailable_none')) + '</div></div></div>' +
        '<ul class="sf-reasons">' + lines + '</ul>' +
        (rec.altSize ? '<button type="button" class="sf-cta sf-cta--ghost" data-pick="' + rec.altSize + '">' + t('cta_ghost', { alt: rec.altSize }) + '</button>' : '');
    } else {
      box.classList.remove('unavail');
      box.innerHTML =
        '<div class="sf-kick">' + t('result_kick') + '</div>' +
        '<div class="sf-hero"><div class="sf-sz">' + rec.size + '</div>' +
        '<div><div class="sf-rt">' + t('result_ok', { size: rec.size }) + '</div>' +
        '<div class="sf-rs">' + t('result_ok_sub') + '</div></div></div>' +
        '<ul class="sf-reasons">' + lines + '</ul>' +
        '<button type="button" class="sf-cta" data-pick="' + rec.size + '">' + t('cta_pick', { size: rec.size }) + '</button>' +
        '<div class="sf-saved">' + t('saved_note') + '</div>';
    }
    var cta = box.querySelector('[data-pick]');
    if (cta) cta.addEventListener('click', function () { applySize(this.getAttribute('data-pick')); });
    renderTable();
  }

  /* ---------- toepassen op de echte maat-chips ---------- */
  function sizeChipFor(size) {
    var chips = document.querySelectorAll('.product__chip[data-option-value]');
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('data-option-value').toUpperCase() === String(size).toUpperCase()) return chips[i];
    }
    return null;
  }
  function announceRec(size){
    window.__clSizeRec = size;
    try { document.dispatchEvent(new CustomEvent('clsf:recommended', { detail: { size: size } })); } catch (e) {}
  }
  function decorate(size) {
    announceRec(size);
    document.querySelectorAll('.product__chip.sf-rec').forEach(function (c) { c.classList.remove('sf-rec'); });
    var chip = sizeChipFor(size);
    if (chip) chip.classList.add('sf-rec');
    var lbl = link.querySelector('[data-sf-link-label]');
    if (lbl) lbl.textContent = t('link_done', { size: size });
    link.classList.add('sf-done');
  }
  function clearApplied() {
    document.querySelectorAll('.product__chip.sf-rec').forEach(function (c) { c.classList.remove('sf-rec'); });
    var lbl = link.querySelector('[data-sf-link-label]');
    if (lbl) lbl.textContent = cap ? t('link_label') : t('table_link_label');
    link.classList.remove('sf-done');
  }
  function applySize(size) {
    var chip = sizeChipFor(size);
    if (chip) chip.click();
    decorate(size);
    closeSheet();
  }

  /* ---------- tabel ---------- */
  function cellText(v, toIn) {
    if (v == null) return '–';
    if (typeof v.v === 'number') return fmtNum(v.v, toIn);
    if (typeof v.min === 'number') return fmtNum(v.min, toIn) + '–' + fmtNum(v.max, toIn);
    return v.raw || '–';
  }
  function fmtNum(n, toIn) {
    if (toIn) return String(Math.round(n / 2.54 * 10) / 10);
    return String(Math.round(n * 10) / 10);
  }
  function renderTable() {
    var toIn = unit === 'in';
    var html = '<div class="sf-unitrow"><div class="sf-hint">' + t('unit_note') + '</div>' +
      '<div class="sf-unittgl"><button type="button" data-u="cm" class="' + (toIn ? '' : 'on') + '">cm</button>' +
      '<button type="button" data-u="in" class="' + (toIn ? 'on' : '') + '">inch</button></div></div>';
    (chart.sections || []).forEach(function (sec) {
      html += '<div class="sf-tblwrap"><table class="sf-tbl"><tr><th>' +
        (sec.kind === 'bottom' ? t('col_size_bottom') : t('col_size')) + '</th>';
      sec.columns.forEach(function (c) {
        var name = c.key === 'alt' || c.key.indexOf('custom') === 0
          ? c.label
          : t('col_' + c.key.replace(/_\d+$/, ''));
        // Een maat is een maat, geen lengte: geen cm/inch achter de kop en niet
        // meeschakelen met de eenheidsknop.
        var suffix = c.key === 'alt' ? '' : (c.unit === 'kg' ? ' (kg)' : (toIn ? ' (in)' : ' (cm)'));
        html += '<th>' + name + suffix + '</th>';
      });
      html += '</tr>';
      sec.rows.forEach(function (r) {
        var sold = !soldSizes.length || soldSizes.some(function (s) { return String(s).toUpperCase() === String(r.size).toUpperCase(); });
        var isRec = state.rec && state.rec.status === 'ok' && String(state.rec.size).toUpperCase() === String(r.size).toUpperCase();
        html += '<tr class="' + (isRec ? 'rec' : '') + (sold ? '' : ' na') + '">';
        html += '<td>' + r.size + (isRec ? '<span class="sf-rectag">' + t('rec_tag') + '</span>' : '') + (sold ? '' : '<span class="sf-natag">' + t('not_available') + '</span>') + '</td>';
        r.values.forEach(function (v, vi) {
          var col = sec.columns[vi];
          var plain = col && (col.key === 'alt' || col.unit === 'kg');
          html += '<td>' + cellText(v, toIn && !plain) + '</td>';
        });
        html += '</tr>';
      });
      html += '</table></div>';
    });
    html += '<div class="sf-hint sf-measured">' + t('measured_note') + '</div>';
    paneTable.innerHTML = html;
    paneTable.querySelectorAll('[data-u]').forEach(function (b) {
      b.addEventListener('click', function () { unit = b.getAttribute('data-u'); renderTable(); });
    });
  }

  /* ---------- init: bestaand profiel → direct decoreren ---------- */
  renderAdvisor();
  if (cap) {
    var arg0 = buildProfileArg();
    if (arg0) {
      var rec0 = E.recommend(chart, arg0);
      if (rec0 && rec0.status === 'ok') { state.rec = rec0; decorate(rec0.size); }
    }
  }
})();
